import cookie from '../cookie'

const enabled = (feature: string): boolean => {
  const cookieOverride = cookie.getCookie(`x-feature-auth0-${feature}`)
  if (cookieOverride) return !!Number(cookieOverride)
  return window.auth?.[feature] ?? false
}

const disabled = (feature: string): boolean => !enabled(feature)

export default {
  enabled,
  disabled,
}
